const messageAlert = () =>{

    $(document).on('click.promo.alert', '[data-alert]', function(e){
        e.preventDefault();
        let alertMessage = $(this).attr('data-alert').replace(/\\n/, '\n');
        alert(alertMessage);
    });

};

export default messageAlert;
